module.exports = __webpack_public_path__ + "img/layout-three-columns.b02853a0.svg";